import { render } from "./Home.vue?vue&type=template&id=59cf415b"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=59cf415b&lang=css"

import exportComponent from "C:\\Users\\DEV-HMP\\Documents\\TPM_Site\\Vendor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__